import React from 'react'

import './index.css'

const DashedLink = ({name, onClick, className}) => {

  return (
    <div>
      <span onClick={onClick} className={`${className} dashed-link`}>{name}</span>
      <br />
    </div>
  )
}

export default DashedLink
